import { render, staticRenderFns } from "./VueUploadMultipleImage.vue?vue&type=template&id=396ccc8d&scoped=true&"
import script from "./VueUploadMultipleImage.vue?vue&type=script&lang=js&"
export * from "./VueUploadMultipleImage.vue?vue&type=script&lang=js&"
import style0 from "./VueUploadMultipleImage.vue?vue&type=style&index=0&id=396ccc8d&lang=scss&scoped=true&"
import style1 from "./VueUploadMultipleImage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ccc8d",
  null
  
)

export default component.exports